<template>
  <div class="container is-fluid">
    <button class="button">{{ applications.length }} applications</button>
    <button class="button is-pulled-right" @click="refreshPage()">Reload Page</button>

    <div class="field is-pulled-right" v-if="!$auth.loading && $auth.isAuthenticated ">
         <div class="select ">
            
            <select  v-model="roundId" @change="changeRound()" >
                <option value="">Select Funding Round ...</option>
                <option v-for="row in rounds" :key="row.id" :value="row.id">{{ row.name }}</option>
            </select>
            
            
        </div>
        <div class="select " v-if="$auth.user.roles.includes('director') || $auth.user.roles.includes('admin')">
            
            <select  v-model="governingBodyId" @change="changeGoverningBody()" >
                <option value="">Select Governing Body ...</option>
                <option v-for="row in governing_bodies" :key="row.id" :value="row.id">{{ row.name }}</option>
            </select>
            
            
        </div>
         <div class="select " v-if="$auth.user.roles.includes('director') || $auth.user.roles.includes('admin')">
            
            <select  v-model="councilAreaId" @change="changeCouncilArea()" >
                <option value="">Select Council Area ...</option>
                <option v-for="row in council_areas" :key="row.id" :value="row.id">{{ row.name }}</option>
            </select>
            
            
        </div>
    </div>

    
    
    <table class="table is-hoverable is-fullwidth is-size-7" id="applicationstable">
    	<thead>
        <th v-if="$auth.user.roles.includes('officer') && $route.params.status == 'officer-completed'">Ranking</th>
    		<th>Name</th>
        <th>Email</th>
        <th>Phone</th>
   	 		<th>Submission Date</th>
   	 		<th>Governing Body</th>
          <th>Status</th>
          <th>Rank</th>
          <th v-if="$route.params.status == 'awarded'">Type</th>
          <th v-if="$route.params.status == 'awarded'">Amount</th>
          <th></th>
    	</thead>
    	<tbody>
		    <tr v-for="(row, index) in applications" :key="index"  >
           <td v-if="showRankingOptions"><input style="width:50px"  type="number" step="1" min="1" max="50" v-model="row.ranking" :tabindex="index+1"/></td>
				<td>
            <span v-if="row.contact_id > 0">
              <router-link :to="{path: '/contacts/' + row.contact_id}" target="_blank">{{row.forename}} {{row.surname}}</router-link>
            </span>
            <span v-else>
            {{row.forename}} {{row.surname}}
            </span>

            <span class="tag is-info" v-if="row.coaching==1">Coaching</span>
         </td>
				<td>{{ row.email }}</td>
        <td>{{ formatPhone(row.telephone, row.mobile) }}</td>
				<td>{{ row.date_formatted}}</td>
        <td>{{ row.governing_body_short_name }}</td>
        <td>{{ showApplicationStatus(row.endorsed, row.awarded)}}</td>
        <td>{{ row.ranking }}</td>
        <td v-if="$route.params.status == 'awarded'">{{ row.funding_type_name }}</td>
        <td v-if="$route.params.status == 'awarded'">{{ row.amount }}</td>
        <td >
            
            <router-link :to="{path:'/applications/' + row.id}" v-if="!$auth.loading && $auth.isAuthenticated && ($auth.user.roles.includes('admin') || $auth.user.roles.includes('officer'))"><button class="button is-info is-small mr-2" tabindex="100">View</button></router-link>
            <router-link :to="{path:'/applications/' + row.id + '/print'}" v-if="!$auth.loading && $auth.isAuthenticated && ($auth.user.roles.includes('director') || $auth.user.roles.includes('admin'))" target="_blank"><button class="button is-warning is-small" tabindex="101">Print</button></router-link>
          
        </td>
			</tr>
      
    	</tbody>
    </table>

    <table class="" id="exporttable" style="display:none">
    	<thead>
        <tr>
    		<th>Forename</th>
        <th>Surname</th>
        <th>Coaching</th>
        <th>Email</th>
        <th>Phone</th>
        <th>Social</th>
        <th>Target Event</th>
        <th>Date</th>
        <th>Venue</th>
        <th>Cost</th>
   	 		<th>Submission Date</th>
   	 		<th>Governing Body</th>
          <th>Status</th>
          <th>Rank</th>
          <th v-if="$route.params.status == 'awarded'">Type</th>
          <th v-if="$route.params.status == 'awarded'">Amount</th>
        </tr>
    	</thead>
    	<tbody>
		    <tr v-for="(row, index) in applications" :key="index"  >
           
				<td>
            {{row.forename}} 
        </td>
        <td>{{row.surname}}</td>
        <td>
            <span  v-if="row.coaching==1">Coaching</span>
         </td>
				<td>{{ row.email }}</td>
        <td>{{ formatPhone(row.telephone, row.mobile) }}</td>
        <td>{{  row.social_handle }}</td>
        <td>{{  row.target_event }}</td>
        <td>{{  row.target_event_date }}</td>
        <td>{{  row.target_event_venue }}</td>
        <td>{{  row.target_event_cost }}</td>
				<td>{{ row.date_raw }}</td>
        <td>{{ row.governing_body_short_name }}</td>
        <td>{{ showApplicationStatus(row.endorsed, row.awarded)}}</td>
        <td>{{ row.ranking }}</td>
        <td v-if="$route.params.status == 'awarded'">{{ row.funding_type_name }}</td>
        <td v-if="$route.params.status == 'awarded'">{{ row.amount }}</td>
        
			</tr>
      
    	</tbody>
    </table>

    <button class="button is-success mr-2 " v-if="showRankingOptions" @click="saveRankingOrders()" :disabled="saving===true" :tabindex="applications.length+2">Save Ranking Orders</button>
    
    <div class="buttons" v-if="showRankingOptions==false">
   
      <button class="button is-success" @click="exportXLS()">Export Results to Excel</button>
    </div>

  </div>
</template>

<script>
import ApplicationService from '@/services/ApplicationService.js';
import XLSX from 'xlsx';

export default {
  components: {
   	
  },
  data() {
    return {
      orders: [],
      errors: [],
      applications: [],
      governing_bodies:[],
      council_areas:[],
      orderBy:"",
      rounds: [],
      accessToken:'',
      saving : false
    }
  },
  props: ['governingBodyId', 'councilAreaId', 'roundId'],
  
  // Fetches posts when the component is created.
  created() {
    this.getAccessToken()
    .then(() => { 
      this.getApplications();
      this.getGoverningBodies();
      this.getCouncilAreas();
      this.getRounds();
    });
  
  },
  computed: {
    showRankingOptions: function() {
      return this.$auth.user.roles.includes('officer') && this.$route.params.status == 'officer-completed' && this.applications.length > 0
    }
  },
  watch: {
    '$route'() {
     this.getApplications();
     this.getGoverningBodies();
     this.getCouncilAreas();
    },
    governingBodyId: function() {
      this.getApplications();
      //this.getGoverningBodies();
      //this.getCouncilAreas();
    },
    councilAreaId: function() {
      this.getApplications();
      //this.getGoverningBodies();
      //this.getCouncilAreas();
    },
    roundId: function() {
      this.getApplications();
      //this.getGoverningBodies();
     // this.getCouncilAreas();
    }
  },
  methods: {
    formatPhone(telephone, mobile) {
      if (telephone && mobile && telephone !== mobile) {
        return `${telephone}/${mobile}`;
      }
      return telephone || mobile || '';
    },
  	refreshPage() {
        this.getApplications();
        this.getGoverningBodies();
        this.getCouncilAreas();
         this.getRounds();
    },
    exportXLS() {
		 //alert("hi")
		 var wb = XLSX.utils.table_to_book(document.getElementById('exporttable'), {sheet:"Sheet JS"});
		 XLSX.writeFile(wb, 'applications-list.xlsx')

	 },
    
    async getGoverningBodies() {
        
      ApplicationService.getGoverningBodies("")
      .then(
        (governing_bodies => {
          this.$set(this, "governing_bodies", governing_bodies);
        }).bind(this)
      );
    },
    async getCouncilAreas() {
       
      ApplicationService.getCouncilAreas("")
      .then(
        (council_areas => {
          this.$set(this, "council_areas", council_areas);
        }).bind(this)
      );
    },
    async getRounds() {
       
      ApplicationService.getRounds(this.accessToken)
      .then(
        (rounds => {
          this.$set(this, "rounds", rounds);
        }).bind(this)
      );
    },
    async getApplications() {
      this.applications = []
      var status = ""
      if(this.$route.params.status != "" && this.$route.params.status != undefined)
      {
         status = this.$route.params.status 
      }

     
      ApplicationService.getApplications(this.accessToken, status, this.governingBodyId, this.councilAreaId, this.orderBy, this.roundId)
      .then(
        (applications => {
          this.$set(this, "applications", applications);
        }).bind(this)
      );
    },
    	async saveRankingOrders() {
        this.saving = true;
        ApplicationService.saveRankingOrders(this.accessToken, this.applications)
        .then(
          (response => {
          console.log(response)
          alert("Ranking orders have been saved.\nApplications may be re-ordered when you next visit this screen.")
          this.saving=false
          })
        )
        .catch(error => {
          alert("An error occured - " + error.message)
          console.error(error.message);
          this.saving=false;
        });
      },
    
     changeGoverningBody()
    {
      this.$emit('changeGoverningBody', this.governingBodyId)
      //alert(governingBodyId)
    },
     changeCouncilAreas()
    {
      this.$emit('changeCouncilArea', this.councilAreaId)
      //alert(governingBodyId)
    },
    changeRound()
    {
      this.$emit('changeRound', this.roundId)
      //alert(governingBodyId)
    }
  }
}

// used to be on button  v-if="this.user["https://app.test202.co.uk/roles"].includes('sales')"
</script>

<style>
	
</style>
